import { z } from 'zod';
import { idArray } from './shared.schema';

export const facilitySettingsReportFormatSchema = z.literal('csv');

export const facilitySettingsParametersSchema = z.object({
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	format: facilitySettingsReportFormatSchema.default('csv'),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
});

export type FacilitySettingsParameters = z.infer<typeof facilitySettingsParametersSchema>;
export type FacilitySettingsReportFormat = z.infer<typeof facilitySettingsReportFormatSchema>;
